module.exports = __webpack_public_path__ + "img/logo-white.4e49e830.png";